/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2DeleteFilled from 'DesignSystem/Svgs/Tysiav2DeleteFilled/index'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/TaskOverlay/Content/Content/Header/DeleteAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 height={24}
 type="ghost"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../DeleteModal/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../DeleteModal/Content'))}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2DeleteFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2DeleteFilled`}
 fill2={dtColorsNeutral400}
 width={14}
 height={14}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}